import { createStore, createEvent, Event } from 'effector';

const flagStore = (initial: boolean = false, reset?: Event<any>) => {
  const $store = createStore(initial);
  const openStore = createEvent<void>();
  const closeStore = createEvent<void>();
  const toggleStore = createEvent<void>();
  const valueStore = createEvent<boolean>();
  const resetStore = reset || createEvent<void>();

  $store
    .on(openStore, () => true)
    .on(closeStore, () => false)
    .on(toggleStore, s => !s)
    .on(valueStore, (_, v) => v)
    .reset(resetStore);

  return {
    $store,
    openStore,
    closeStore,
    toggleStore,
    valueStore,
    resetStore
  };
};

type FlagStoreType = ReturnType<typeof flagStore>;

export { flagStore };
export type { FlagStoreType };
